export default __webpack_public_path__ + "static/media/ativo.3b681f17.svg";